import { login } from '@dvag/dfs-orchestrator-client/messengers';

import { getMonitoring } from './getMonitoring';

let isHandlingInvalidToken = false;

export const handleInvalidToken = async () => {
  if (isHandlingInvalidToken) {
    return;
  }

  isHandlingInvalidToken = true;

  const monitoring = getMonitoring();

  try {
    monitoring.trackEvent({
      name: 'auth.expired-token',
      properties: {
        level: 'warning',
      },
    });

    await monitoring.flush();
  } finally {
    login();
  }
};
